import { useNavigationGuard } from "./useNavigationGuard";
import { useUnsavedChanges } from "../context/UnsavedChangesContext";

export function useGlobalNavigationGuard() {
    const { isDirty } = useUnsavedChanges();

    useNavigationGuard(isDirty, () => {
        return window.confirm("You have unsaved changes. Leave?");
    });
}
